import Regular from "./regular";
import Detailed from "./detailed";
import ButtonView from "./buttonView";
import SquareBox from "./squareBox";
import { UserProvider } from "./provider";
import Name from "./_name";
import Bio from "./_bio";
import Image from "./_image";
import VerifiedBadge from "./_verifiedBadge";
import FollowButton from "./_followBtn";
import ConnectButton from "./_connectBtn";
import OptionsButton from "./_optionsBtn";
import SearchItem from "./searchItem";

const User = {
  Regular,
  NavigationButton: ButtonView,
  Detailed,
  SquareBox,
  Container: UserProvider,
  Name,
  Bio,
  Image,
  VerifiedBadge,
  FollowButton,
  ConnectButton,
  OptionsButton,
  SearchItem
};

export default User;
